import { render, staticRenderFns } from "./registerTemplate.vue?vue&type=template&id=d02fbb50"
import script from "./registerTemplate.vue?vue&type=script&lang=js"
export * from "./registerTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports